import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { NationalityFacade } from '@portal/application/data-access';
import { map } from 'rxjs';
import { mapNationalitiesToFormlySelectOption } from '../util';

@Injectable()
export class NationalityPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly nationalityFacade = inject(NationalityFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'Nationality',
        placeholder: 'Please Select',
        options: this.nationalityFacade.allNationality$?.pipe(map(o => mapNationalitiesToFormlySelectOption(o))),
      },
    };
  }
}

export function registerNationalityPreset(): ConfigOption {
  return { presets: [{ name: 'nationality', config: new NationalityPresetProvider() }] };
}
